import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

import { AuthService } from '../../core';

@Component({
  standalone: false,
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {
  public hidePassword = true;
  public isSubmitting = false;
  public error = '';
  myControl = new FormControl('', [
    Validators.required,
    Validators.maxLength(20),
    Validators.pattern('^[A-Za-z\\s]+$')
  ]);

  constructor(public authService: AuthService) {}

  ngOnInit() {}

  getErrorMessage() {
    return this.myControl.hasError('required')
      ? 'Campo obligatorio'
      : this.myControl.hasError('maxlength')
      ? 'Inválido Máximo 20'
      : this.myControl.hasError('pattern')
      ? 'Caracter inválido'
      : '';
  }

  onSubmit = () => {
    this.isSubmitting = true;
    this.error = '';
  }
}
